import { useCallback } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
const RESPONSE_TYPE = 'code';
const SCOPES = 'email profile';
const PROMPT = 'select_account';

interface IGoogleLoginOptions {
  redirectUri: string;
  state?: string;
}

/**
 * Builds Google's OAuth authorization-code URL. This replaces the Google Identity Services script
 * (`accounts.google.com/gsi/client`), which we only used in redirect mode — where it does nothing
 * but navigate to this URL. Loading it unversioned, with no integrity hash, was flagged by the PCI scan.
 */
export const buildGoogleAuthUrl = ({ redirectUri, state }: IGoogleLoginOptions): string => {
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: RESPONSE_TYPE,
    scope: SCOPES,
    prompt: PROMPT,
    ...(state ? { state } : {}),
  });

  return `${GOOGLE_AUTH_URL}?${params.toString()}`;
};

export const useGoogleLogin = ({ redirectUri, state }: IGoogleLoginOptions) => {
  const googleAuthInit = useCallback(() => window.location.assign(buildGoogleAuthUrl({ redirectUri, state })), [redirectUri, state]);

  return { googleAuthInit, googleUnavailable: !CLIENT_ID };
};
